import React, { useState, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import { Layout, Space, Button, Form, Row, Col, Input, Table, Radio, Badge, Modal, message, Tag, Tooltip } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import { ColumnsType } from "antd/lib/table";
import { useStore } from "../../store";
import { getManagerCommentInfo, delCommentInfo, toCommentTop } from '../../http/manager';
import { transaction } from "mobx";
import { useLocation } from 'react-router-dom';
import { CommentEntity } from '../../entity/comment-entity';

const ScienceList: React.FC = ()=> {
    const location = useLocation()
    const { state } = location
    const { scienceStore } = useStore();
    const [details, setDetail] = useState({id: ''});
    let ID = useRef<string>();

    useEffect(()=> {
        setDetail(JSON.parse(state.scienceDetail));
        ID.current = JSON.parse(state.scienceDetail).id;
        getList();
        return;
    }, [])
    const getList = ()=> {
        let params = {
            pid: ID.current,
            userid: scienceStore.commentCondition.userid
        }
        params = scienceStore.commentCondition.anonymous === -1 ? params : Object.assign(params, {anonymous: scienceStore.commentCondition.anonymous})
        getManagerCommentInfo(params).then((res:any) => {
            refreshTableData((res.data && res.data.length > 0) ? res.data : []);
        })
    }

    const refreshTableData = (data: CommentEntity[]) => {
        const list: CommentEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        transaction(() => {
            scienceStore.setCommentSource(list);
        })
    }
    const columns: ColumnsType<CommentEntity> = [
        {
            title: '序号',
            width: 70,
            dataIndex: 'id',
            key: 'id',
            align: "center",
            render: (value, record, index) => {
                return <div>{index + 1}</div>
            }
        },
        {
            title: '置顶状态',
            dataIndex: 'totop',
            key: 'totop',
            align: "center",
            render:(totop)=> {
                if(totop == 1) {
                    return <Tag color="#f50">已置顶</Tag>
                }else {
                    return <Tag color="#999">未置顶</Tag>
                }
            }
        },
        {
            title: '评论人',
            dataIndex: 'userid',
            key: 'userid',
            align: "center",
            render: (value, record, index) => {
                return value ? <div>{value}</div> : '-'
            }
        },
        {
            title: '评论内容',
            dataIndex: 'content',
            align: "center",
            key: 'content',
            width: '600px',
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            ),
        },
        {
            title: '匿名状态',
            dataIndex: 'anonymous',
            key: 'anonymous',
            align: "center",
            render:(value)=> {
                if(value === 0) {
                    return <Badge status="success" text="实名"/>
                }else if(value === 1) {
                    return <Badge status="default" text="匿名"/>
                }
            },
        },
        {
            title: '创建时间',
            dataIndex: 'createtime',
            align: "center",
            key: 'createtime'
        },
        {
            title: '操作',
            width: 240,
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            align: "center",
            render: (value, record) => {
                return <Space size="middle">
                    { record.totop === 1 ?
                    <Button onClick={() => toppingCancel(record)} type={"default"} size={ 'small' }>取消置顶</Button> :
                    <Button onClick={() => toppingConfirm(record)} type={"primary"} size={ 'small' }>置顶</Button>
                    }
                    <Button onClick={() => openDeleteConfirm(record)} type={"primary"} size={ 'small' } danger={true}>删除</Button>
                </Space>
            }
        },
    ]
    const toppingConfirm = (record: CommentEntity) => {
        scienceStore.setToppingRecord(record);
        scienceStore.setShowTopping(true);
    }
    const toppingCancel = (record: CommentEntity) => {
        scienceStore.setToppingRecord(record);
        scienceStore.setShowCancelTopping(true);
    }
    const openDeleteConfirm = (record: CommentEntity) => {
        scienceStore.setDeleteCommentRecord(record);
        scienceStore.showDeleteConfirm(true);
    }
    const setUserid = (e:any)=> {
        scienceStore.commentCondition.userid = e.target.value;
    }
    const setAnonymous = (e:any)=> {
        scienceStore.commentCondition.anonymous = e.target.value;
    }
    const onQuery = ()=> {
        getList();
    }
    const onResetOnclick = ()=> {
        scienceStore.resetScienceCommentCondition();
        getList();
    }
    const onDeleteConfirmClose = () => {
        scienceStore.showDeleteConfirm(false);
    }
    const onToppingConfirmClose = () => {
        scienceStore.setShowTopping(false);
    }
    const onToppingCancelConfirmClose = () => {
        scienceStore.setShowCancelTopping(false);
    }
    const deleteButton = () => {
        const params = {
            id: scienceStore.deleteCommentRecord.id,
        }
        deleteBaseLibrary(params)
    }
    const deleteBaseLibrary = (params: any) => {
        delCommentInfo(params).then((res) => {
            if (Number(res.code) === 200) {
                message.success("删除成功");
                onDeleteConfirmClose();
                getList();
            } else {
                if (res.message) {
                    message.error(res.message);
                } else {
                    message.error("删除失败");
                }
            }
        }).catch(() => {
            message.error("删除失败");
        })
    }
    const toppingButton = (state: number)=> {
        const formData = new FormData();
        formData.append('id', scienceStore.toppingRecord.id.toString());
        formData.append('totop', state.toString());
        toCommentTop(formData).then(res=> {
            if (Number(res.code) === 200) {
                if(state === 1) {
                    message.success("置顶成功");
                    onToppingConfirmClose();
                }else{
                    message.success("取消成功");
                    onToppingCancelConfirmClose();
                }
                getList();
            } else {
                if (res.message) {
                    message.error(res.message);
                } else {
                    message.error("操作失败");
                }
            }
        })
    }
    const back = () => {
      window.history.back();
    }
    return (
        <Layout style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Header style={{background: "#ffffff", borderBottom: "1px solid #d3d3d3", padding: "0"}}>
                <TitleSpan><span onClick={back}> &lt; </span>评论列表</TitleSpan>
            </Header>
            <Content style={{ flex: 1, overflow: 'hidden' }}>
                <Wrapper>
                    <SearchWrapper>
                        <Form labelAlign={"right"} wrapperCol={{span: "15"}} style={{margin: "15px 0 0 0"}} >
                            <Row justify={"space-between"} gutter={[15, 0]}>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"评论人"}>
                                        <Input placeholder={"请输入"} onChange={setUserid} value={scienceStore.commentCondition.userid}/></Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item labelCol={{span:"7"}} label={"匿名状态"}>
                                        <Radio.Group onChange={setAnonymous} value={scienceStore.commentCondition.anonymous}>
                                            <Radio value={-1}>全部</Radio>
                                            <Radio value={1}>匿名</Radio>
                                            <Radio value={0}>实名</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Space size={["middle", "large"]}>
                                        <Button onClick={ onQuery } type={"primary"}>查询</Button>
                                        <Button onClick={ onResetOnclick } type={"default"}>重置</Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </SearchWrapper>
                    <ContentWrapper>
                        <Table
                            rowClassName={(type, index, intent) => {
                                return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                            }}
                            size={"small"}
                            bordered={true}
                            dataSource={scienceStore.commentSource}
                            columns={columns}
                        />
                    </ContentWrapper>
                </Wrapper>
                <Modal onCancel={onDeleteConfirmClose}
                       onOk={deleteButton}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={scienceStore.isShowDeleteCOnfirm}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认删除该数据</div>
                </Modal>
                <Modal onCancel={onToppingConfirmClose}
                       onOk={()=> toppingButton(1)}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={scienceStore.isShowTopping}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认置顶该数据</div>
                </Modal>
                <Modal onCancel={onToppingCancelConfirmClose}
                       onOk={()=> toppingButton(0)}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={scienceStore.isShowCancelTopping}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认取消置顶该数据</div>
                </Modal>
            </Content>
        </Layout>
    )
}

export default observer(ScienceList);

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    line-height: 16px;
    text-align: center;
    color: #333333;
    font-weight: 450;
    margin-left: 15px;
    span {
        cursor: pointer;
    }
  }
`;
const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }

    .ant-table-body {
      overflow-x: scroll !important;
    }
  }
`;
const SearchWrapper = styled.div`
  & {
    margin: 15px 15px 0 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .ant-picker{
      width: 100%;
    }
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 15px;
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
  }
`;